// extracted by mini-css-extract-plugin
module.exports = {"corpo":"Consultar_corpo__3ikfy","tituloCard":"Consultar_tituloCard__nru0u"};